import { supabase } from './supabase';

// Team tags (migration 048) — a public label for the people who run DSP Cafe,
// shown beside their name on posts, replies, comments and profiles.
//
// ⚠️ Set ONLY by an admin, through admin_set_team_tag. The table has no client
// policies, so a member cannot give themselves a "Moderator" tag. Tags are
// independent of app_role on purpose: permissions are not a public title, and
// "superadmin" is not something to print on a byline.
//
// The ids mirror team_tags.tag's CHECK in 048; labels live only here.
export const TEAM_TAGS = [
  { id: 'cafe_team', label: 'Cafe Team' },
  { id: 'moderator', label: 'Moderator' },
  { id: 'developer', label: 'Developer' },
  { id: 'admin',     label: 'Admin' },
];

export function teamTagLabel(id) {
  return TEAM_TAGS.find((t) => t.id === id)?.label ?? null;
}

// The whole list is a handful of rows, so it is fetched once and shared by
// every byline on the page instead of widening four read RPCs to carry it.
const TTL_MS = 10 * 60_000;
let cache = null;        // Map<user_id, tag>
let fetchedAt = 0;
let inflight = null;
const listeners = new Set();

export function getCachedTeamTags() {
  return cache;
}

export function loadTeamTags(force = false) {
  if (!force && cache && Date.now() - fetchedAt < TTL_MS) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = supabase.rpc('get_team_tags').then(({ data, error }) => {
    inflight = null;
    if (error) {
      console.error('get_team_tags:', error);
      return cache ?? new Map();
    }
    cache = new Map((data ?? []).map((r) => [r.user_id, r.tag]));
    fetchedAt = Date.now();
    listeners.forEach((fn) => fn(cache));
    return cache;
  });
  return inflight;
}

export function subscribeTeamTags(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
